import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {GroupUserModel} from '@/libs/Api';
import {GroupUsersDataService} from '@/libs/group-users/group-users-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const groupUsersStore = registerCrudStore<GroupUserModel, GroupUserModel>(BusinessModule.GroupUser, new GroupUsersDataService());
